import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface PersonEmailValidationResponse {
  isAvailable: boolean;
  message: string;
  details?: {
    existsInCognito: boolean;
    existsInDatabase: boolean;
    userType?: 'person' | 'company';
    emailVerified?: boolean;
    actionTaken?:
      | 'none'
      | 'deleted_cognito_orphan'
      | 'deleted_db_orphan'
      | 'deleted_unverified_user';
  };
}

@Injectable({
  providedIn: 'root',
})
export class PersonValidationService {
  private baseUrl = environment.apiNest;

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      skip: 'true',
    });
  }

  /**
   * Valida si un email está disponible para registro de persona
   * @param email - Email a validar
   * @returns Promise con la respuesta de validación
   */
  async validatePersonEmail(
    email: string
  ): Promise<PersonEmailValidationResponse> {
    const url = `${this.baseUrl}public/person-validation/validate-email`;
    const body = { email };
    const headers = this.getHeaders();

    try {
      const response = await firstValueFrom(
        this.http.post<PersonEmailValidationResponse>(url, body, { headers })
      );
      return response;
    } catch (error: any) {

      // Si es error 429 (rate limit), lanzar mensaje específico
      if (error?.status === 429) {
        throw {
          message: 'Demasiadas solicitudes. Por favor, espera un momento.',
          detail: error?.error || error?.message || error,
          statusCode: 429,
        };
      }

      throw {
        message: 'Error validando el email',
        detail: error?.error || error?.message || error,
        statusCode: error?.status || 500,
      };
    }
  }
}
